import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild,
	inject,
} from '@angular/core';
import { MatterFormViewerComponent } from '@components/matter-form-viewer/matter-form-viewer.component';
import { MatterFileType } from '@models/matter';
import { PDFForm, PDFFormType, PDFForms } from '@models/matter-form-data';
import { Store } from '@ngxs/store';
import { SelectedMatterFormsDispatch } from '@state/global/forms/selected-matter-forms.dispatch';
import {
	SelectedForm,
	SelectedMatterFormsState,
} from '@state/global/forms/selected-matter-forms.state';
import { BaseFormMapper } from 'src/app/private/sale/documents/forms/mappers/base-form-mapper';
import { TestHooks } from './matter-form-viewer-container.hooks';

@Component({
	selector: 'app-matter-form-viewer-container',
	templateUrl: './matter-form-viewer-container.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterFormViewerContainerComponent {
	testHooks = TestHooks;
	public url: string;
	public form: PDFForm;
	public formTypes = PDFFormType;
	public pdfTronFormData = {};

	public formMap: BaseFormMapper;
	public selectedForm: SelectedForm;
	public mergedFormData;
	public mappings;

	public PDFForms = PDFForms;
	public matterFileTypes = MatterFileType;
	public _formId: PDFFormType;
	public showPlaceholder = false;

	@ViewChild(MatterFormViewerComponent)
	matterFormViewer: MatterFormViewerComponent;

	selectedForm$ = inject(Store).select(
		SelectedMatterFormsState.getSelectedForm,
	);

	@Input() showCloseButton: boolean = false;

	@Output() onClose: EventEmitter<void> = new EventEmitter<void>();
	@Output() finishedRendering: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private selectedMatterFormsDispatch: SelectedMatterFormsDispatch,
	) {}

	onFieldChanged($event) {
		this.selectedMatterFormsDispatch.SetSelectedFormField(
			$event.field,
			$event.value,
		);
	}

	public download() {
		this.matterFormViewer.download();
	}

	public print() {
		this.matterFormViewer.print();
	}

	public printInBackground() {
		this.matterFormViewer.printInBackground();
	}

	public _onClose() {
		this.onClose.emit();
	}

	public _finishedRendering() {
		this.finishedRendering.emit();
	}
}
